import { render } from "./Home.vue?vue&type=template&id=dfc570ee&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dfc570ee&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc570ee"]])

export default __exports__